/**
 * サブヘッダー
 */
import { Component } from '@angular/core';
import { CommonLibService } from '@lib/services';
import { SupportComponent } from '@lib/components/support-class';
import { Router } from '@angular/router';

/**
 * サブヘッダー
 */
@Component({
  selector: 'asw-service-request-completed-sub-header',
  templateUrl: './service-request-completed-sub-header.component.html',
  providers: [],
})
export class ServiceRequestCompletedSubHeaderComponent extends SupportComponent {
  constructor(private _common: CommonLibService, private _router: Router) {
    super(_common);
  }

  reload(): void {}
  init(): void {}
  destroy(): void {}
}
